import { EntityProfilePlaceholderTab } from '@features/Shared/EntityProfile/EntityProfilePlaceholderTab'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslations } from '@utils/i18n-to-migrate'

export const Route = createFileRoute('/framework/forestowner/$forestownerId/shareownership')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Andelseierskap',
  },
})

function RouteComponent() {
  const { t } = useTranslations()
  return (
    <EntityProfilePlaceholderTab
      title={t('forestowner-search-overview.tabs.shareOwnership')}
      description={t('framework-forestownersandbox.placeholderDescription')}
    />
  )
}
